import { render, staticRenderFns } from "./data.vue?vue&type=template&id=5214108e&scoped=true"
import script from "./data.vue?vue&type=script&lang=js"
export * from "./data.vue?vue&type=script&lang=js"
import style0 from "../../style/common-pc.scss?vue&type=style&index=0&id=5214108e&prod&lang=scss&scoped=true&external"
import style1 from "./data.vue?vue&type=style&index=1&id=5214108e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../content-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5214108e",
  null
  
)

export default component.exports